import { render, staticRenderFns } from "./MissingMandatory.vue?vue&type=template&id=e72080a6&scoped=true&"
import script from "./MissingMandatory.vue?vue&type=script&lang=ts&"
export * from "./MissingMandatory.vue?vue&type=script&lang=ts&"
import style0 from "./MissingMandatory.vue?vue&type=style&index=0&id=e72080a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72080a6",
  null
  
)

export default component.exports